import { Injectable } from '@angular/core';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class JiraAuthService {

  constructor(public rest: RestService) { }

  public jiraAuthToken(code: string) {
    let apiBody = {      
        "code":code,
        "agileUserName":"",
        "agilePassword":"",
        "project_management_type":"jira",
        "baseUrl":""    
    }
    return this.rest.post('addProjectManagementUser', apiBody, null);
  }

  public isJiraIntegrationAvailable() {
    return this.rest.get('checkProjectManagementIntegrationStatus', "jira", null)
  }

  public getJiraIntegrationUrl(): any {
    return this.rest.get("getJiraIntegrationUrl", null);
  } 
}
